import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'add-script-blog',
  templateUrl: './add-script-blog.component.html',
  styleUrls: ['./add-script-blog.component.scss']
})
export class AddScriptBlogComponent  {
  @Input() blogChannel;
  @Output() finishAddingScript = new EventEmitter<any>();
  @Output() closeAddScriptBox = new EventEmitter<any>();
  public copyScriptTooltip;
  constructor(private translate: TranslateService) {
    this.copyScriptTooltip = this.translate.instant('influencer_settings.copy_script');
  }

  cancelAddScript() {
    this.closeAddScriptBox.emit();
  }

  finishAddScript() {
    this.finishAddingScript.emit(this.blogChannel);
  }

  copyScript() {
    this.copyScriptTooltip = this.translate.instant('influencer_settings.copied_script');
    const copyText = document.getElementById('scriptContent') as HTMLInputElement;
    copyText.select();
    document.execCommand('copy');
  }

  closeTooltip() {
    this.copyScriptTooltip = this.translate.instant('influencer_settings.copy_script');
    const tooltip = document.querySelector('#scriptTooltip');
    if (tooltip) {
      tooltip.classList.remove('shown');
    }
  }

  openTooltip() {
    const tooltip = document.querySelector('#scriptTooltip');
    if (tooltip) {
      tooltip.classList.add('shown');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/add-script-blog/add-script-blog.component.ts